import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthService, UserService } from '@src/domain/services';

/** 使用者資訊 */
interface UserInfo extends AuthService.LoginBo {}

/** 頁面權限 */
interface PagePermissions extends UserService.PagePermissionsBo {}

export interface UserState {
  userInfo: UserInfo | null;
  pagePermissions: PagePermissions | null;
}

/** 使用者 */
export const userSlice = createSlice({
  name: 'user',
  initialState: {
    /** 使用者資訊 */
    userInfo: null,
    /** 頁面權限 */
    pagePermissions: null
  } as UserState,
  reducers: {
    setUserInfo(state, action: PayloadAction<UserInfo | null>) {
      state.userInfo = action.payload
    },
    clearUserInfo(state) {
      state.userInfo = null
    },
    setPagePermissions(state, action: PayloadAction<PagePermissions | null>) {
      state.pagePermissions = action.payload
    },
    clearPagePermissions(state) {
      state.pagePermissions = null
    }
  }
})

export const userReducer = userSlice.reducer
export const userActions = userSlice.actions
